import React, { useEffect, useState } from "react";
import { MdAdd } from "react-icons/md";
import { useGetCategoryQuery } from "../../../features/api/categoryApi";
import { useAddProductMutation } from "../../../features/api/productApi";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../../components/baseUrl";

const AddSubItem = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const { data, error, isLoading } = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = data?.categories;

  const [cat_name, setCategory] = useState("");
  const [sub_catName, setSubCategory] = useState("");
  const [product_name, setProduct] = useState("");

  const [subCatByCat, setSubCatByCat] = useState([]);
  const [relode, setRelode] = useState(false);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/sub-categories/${cat_name}`)
      .then((res) => res.json())
      .then((data) => {
        setSubCatByCat(data?.subCategory);
        setRelode(!relode);
      });
  }, [cat_name]);

  const [addNewProduct] = useAddProductMutation();
  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const newProduct = {
        cat_name,
        sub_catName,
        product_name,
      };
      const response = await addNewProduct(newProduct);
      if (response?.data) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Product create success...!!!");
      } else if (response?.error) {
        setIsOpen(false);
        toast.error("Product create error");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span
        onClick={openModal}
        className="flex items-center justify-between rounded-sm px-3 py-1 text-white bg-blue-500 font-medium text-sm cursor-pointer"
      >
        <MdAdd size={20} /> New Sub-Item
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md lg:w-[400px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <h1 className="font-medium">Create Product</h1>
              <div className="card-body">
                <form
                  onSubmit={handleAdd}
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col gap-4 w-full">
                    <select
                      onChange={(e) => setCategory(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                    >
                      <option>--select--</option>
                      {categories?.map((category) => (
                        <option key={category?.id} value={category?.id}>
                          {category?.cat_name}
                        </option>
                      ))}
                    </select>

                    <select
                      onChange={(e) => setSubCategory(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                    >
                      <option>--select--</option>
                      {subCatByCat?.map((category) => (
                        <option key={category?.id} value={category?.id}>
                          {category?.sub_catName}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      onChange={(e) => setProduct(e.target.value)}
                      className="border pl-1 h-8 bg-slate-50"
                      placeholder="Product"
                    />
                  </div>
                  <button
                    type="submit"
                    className="bg-blue-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddSubItem;
